import React from 'react'
import './css/Webinar.css'

const Webinar = () => {
    return (
        <div className="row">
            <div className="col-md-6 col-lg-4 mb-4" data-aos="fade-up" data-aos-duration="500">
                <div className="card tabCards">
                    <div className="card-body">
                        <h5 className="card-title blueTxt">Get the Right Nonprofit Technology Solution for the Right Cause</h5>
                        <p className="card-text">From small community initiatives to large-scale charities, every nonprofit needs the right technology solution to remain competitive, streamline fundraising efforts, and optimize its program delivery needs.</p>
                        <a href="https://www.beyondkey.com/on-demand-webinar-on-right-cause-nonprofit-solution" target="_blank" className="card-link"><span className="icon-arrow"></span></a>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Webinar